import { IBatchjob } from "@mctypes/batchjob.types";
import { IChecklistPopulated } from "@mctypes/checklist.types";
import { IValueLabel } from "@mctypes/global.types";
import { IMeeting } from "@mctypes/meeting.types";
import { IReport } from "@mctypes/report.types";
import { IIssueBoardApi } from "@mcapps/shared";
import { TypeOfChecklistEnum } from "../routes/checklist/ChecklistConstants";

export const convertProjectUrlToValueAndLabels = (
  url: string,
  projectName,
  issueBoard: Pick<IIssueBoardApi, "name"> | null,
  checklist: IChecklistPopulated,
  batchjobs: IBatchjob.IBatchJobBoardPopulated[],
  useDashboardAsDefaultStartPage: boolean,
  activeReport: IReport.IReportBoardPopulated,
  activeMeeting: IMeeting.MeetingPopulated,
): IValueLabel[] => {
  const arr = url.split("/");

  const lastString = arr[arr.length - 1];
  const projectId = arr[2];

  const appUrlName = arr[3];

  const endsWithAMongoId = lastString.length === 24;

  const startValueAndLabel = {
    label: projectName,
    value: useDashboardAsDefaultStartPage === false ? `/project/${projectId}/apps` : `/project/${projectId}/dashboard`,
  };

  if (appUrlName === "apps") {
    return [startValueAndLabel];
  }

  if (appUrlName === "bimai") {
    return [
      startValueAndLabel,
      {
        label: "BIM AI",
        value: url,
      },
    ];
  }

  if (appUrlName === "dashboard") {
    return [
      startValueAndLabel,
      {
        label: "Dashboard",
        value: url,
      },
    ];
  }

  if (appUrlName === "mccos") {
    return [
      startValueAndLabel,
      {
        label: "COS & MMI",
        value: url,
      },
    ];
  }

  if (appUrlName === "bimFloorplan") {
    return [
      startValueAndLabel,
      {
        label: "BIM planvisning",
        value: url,
      },
    ];
  }

  if (appUrlName === "brannrapport") {
    return [
      startValueAndLabel,
      {
        label: "Brannrapport",
        value: url,
      },
    ];
  }

  if (appUrlName === "viewer") {
    return [
      startValueAndLabel,
      {
        label: "BIM Viewer",
        value: url,
      },
    ];
  }

  if (appUrlName === "members") {
    return [
      startValueAndLabel,
      {
        label: "Medlemmer",
        value: url,
      },
    ];
  }

  if (appUrlName === "settings") {
    return [
      startValueAndLabel,
      {
        label: "Prosjektinnstillinger",
        value: url,
      },
    ];
  }

  //***Issues**//

  if (lastString === "issues") {
    return [
      startValueAndLabel,
      {
        label: "Register",
        value: `/project/${projectId}/${appUrlName}`,
      },
    ];
  }

  if (appUrlName === "issues-multiregister") {
    return [
      startValueAndLabel,
      {
        label: "Register",
        value: `/project/${projectId}/issues`,
      },
      {
        label: "Flere registre",
        value: url,
      },
    ];
  }

  if (appUrlName === "issues" && endsWithAMongoId === true) {
    const parts = [
      startValueAndLabel,
      {
        label: "Register",
        value: `/project/${projectId}/${appUrlName}`,
      },
    ];

    if (issueBoard?.name != null) {
      parts.push({
        label: issueBoard.name,
        value: url,
      });
    }

    return parts;
  }

  //***Checklist**//

  if (appUrlName === "checklist") {
    const typeofChecklist = arr[4];

    const baseChecklist = {
      label: "Sjekkliste",
      value: `/project/${projectId}/${appUrlName}`,
    };

    if (
      (typeofChecklist === TypeOfChecklistEnum.CHECKLIST || typeofChecklist === TypeOfChecklistEnum.TEMPLATE) &&
      endsWithAMongoId === false
    ) {
      return [startValueAndLabel, baseChecklist];
    }

    if (typeofChecklist === TypeOfChecklistEnum.CHECKLIST && endsWithAMongoId === true) {
      return [
        startValueAndLabel,
        baseChecklist,
        {
          label: "Instans",
          value: `/project/${projectId}/${appUrlName}/${TypeOfChecklistEnum.CHECKLIST}`,
        },
        {
          label: checklist?.name,
          value: url,
        },
      ];
    }

    if (typeofChecklist === TypeOfChecklistEnum.TEMPLATE && endsWithAMongoId === true) {
      return [
        startValueAndLabel,
        baseChecklist,
        {
          label: "Prosjektmaler",
          value: `/project/${projectId}/${appUrlName}/${TypeOfChecklistEnum.TEMPLATE}`,
        },
        {
          label: checklist?.name,
          value: url,
        },
      ];
    }
  }

  //***Batchjob**//

  if (appUrlName === "batchjob") {
    const base = {
      label: "Batch Job",
      value: `/project/${projectId}/${appUrlName}`,
    };

    if (lastString === appUrlName) {
      return [startValueAndLabel, base];
    }

    const boardId = arr[5];
    const board = {
      label: batchjobs?.find((item) => item._id === boardId)?.name,
      value: url,
    };

    if (lastString === "settings") {
      return [startValueAndLabel, base, board];
    }

    if (lastString === "log") {
      return [startValueAndLabel, base, board];
    }

    /* if (endsWithAMongoId === false) {
      return [startValueAndLabel, base];
    }

    if (endsWithAMongoId === true) {
      return [
        startValueAndLabel,
        base,
        {
          label: issueBoards.find((board) => board._id === lastString)?.name,
          value: url,
        },
      ];
    }*/
  }

  //***Reports**//

  if (appUrlName === "reports") {
    const base = {
      label: "Rapporter",
      value: `/project/${projectId}/${appUrlName}`,
    };

    if (lastString === appUrlName) {
      return [startValueAndLabel, base];
    }

    if (endsWithAMongoId === true) {
      const report = {
        label: activeReport?.name,
        value: url,
      };
      return [startValueAndLabel, base, report];
    }
  }

  if (appUrlName === "meetings") {
    const base = {
      label: "Møter",
      value: `/project/${projectId}/${appUrlName}`,
    };

    if (lastString === appUrlName) {
      return [startValueAndLabel, base];
    }

    /*if (endsWithAMongoId === true) {
      const report = {
        label: activeMeeting?.name,
        value: url,
      };
      return [startValueAndLabel, base, report];
    }*/
  }

  if (appUrlName === "meetings" && endsWithAMongoId === true) {
    return [
      startValueAndLabel,
      {
        label: "Møter",
        value: `/project/${projectId}/${appUrlName}`,
      },
      {
        label: activeMeeting?.name,
        value: url,
      },
    ];
  }

  return [];
};
